import _ from 'lodash';
import { useEffect } from 'react';
import { showMessage } from '~/helper';
import api from '~/services/api';
import useGlobalContext from '~/view-data/use-global-context';
import useFetch from '~/view-data/use-fetch';
import useHeader from '~/view-data/use-header';

const initialState = {
  loading: false,
  formLoading: false,
  term: null,
  offset: 0,
  model: null,
  data: { rows: [], count: 0, offset: 0 },
};

const useReports = () => {
  const { state: { reportsList = initialState }, dispatch } = useGlobalContext('reportsList'),
    { actions: headerActions } = useHeader();

  const failure = (error) => {
    dispatch({ loading: false, formLoading: false, modalLoading: false });
    showMessage('error', error);
  };

  const { data } = useFetch({
    url: 'reports/list',
    params: { term: reportsList.term, offset: reportsList.offset },
  });

  useEffect(() => {
    headerActions.configure({
      title: 'Lista de Parceiros/Clientes',
      count: _.get(data, 'count', 0),
      loading: _.get(reportsList, 'loading', false),
      onSearch: (text) => list(0, text),
    });
    // eslint-disable-next-line
  }, [data, reportsList]);

  const list = (offset = 0, term) => {
    dispatch({ offset, term });
  };

  const pageChange = (offset = 0) => {
    dispatch({ offset });
  };

  const load = async (data = {}) => {
    try {
      let id = data.id || 'new',
        model = { active: true };

      dispatch({ model: {}, formLoading: true });
      if (id !== 'new') {
        const response = await api.get('reports/load', { params: { id } });
        model = _.get(response, 'data') || {};
      }
      dispatch({ model, formLoading: false });
    } catch (error) {
      failure(error);
    }
  };

  return {
    state: {
      ...reportsList,
      data: data || {},
      loading: !data,
    },
    actions: {
      pageChange,
      load,
      list,
    },
  };
};

export default useReports;